import {Bank, UserBank, UserBankPayload} from "../models/bank.model";

export class GetUserBankListAction {
  static readonly type = '[Bank] GetUserBankListAction';
}
export class CreateUserBankAction {
  static readonly type = '[Bank] CreateUserBankAction';
  constructor(public payload: UserBankPayload) {}
}
export class SetFavoriteUserBankAction {
  static readonly type = '[Bank] SetFavoriteUserBankAction';
  constructor(public payload: UserBank) {}
}
export class DeleteUserBankAction {
  static readonly type = '[Bank] DeleteUserBankAction';
  constructor(public payload: UserBank) {}
}

